import { connect } from 'react-redux';
import moment from 'moment';
import { sortBy } from 'lodash';

import store from '@tvguide/store';
import ChannelColumn from './channelcolumn';
import { requestProgramDetails } from '@tvguide/store/actions/requests';
import { setDetailPanelTarget } from '@store/actions/ux';

const mapStateToProps = (state, ownProps) => {
  const activeDay = moment(state.ux.activeDay);

  return {
    programs: sortBy(
      ownProps.channelPrograms.filter(p => {
        return activeDay.isSame(p.start_time, 'day') && p.start_time;
      }),
      ['start_time'],
    ),
    detailPanelProgramId: state.ux.detailPanel.id,
    accessibility: state.ux.accessibilities,
    highlights: state.ux.highlights.filter(el => el.value),
  };
};

const mapDispatchToPros = dispatch => ({
  displayProgramDetails: (sid, id, pid) => {
    const nid = store.getState().ux.nid;
    const targetChan = store.getState().channels.find(c => c.service_id == sid);
    const targetProg = targetChan.programs.find(p => p.program_id == pid);

    dispatch(setDetailPanelTarget(id));
    dispatch(
      requestProgramDetails(
        sid,
        nid,
        id,
        pid,
        encodeURIComponent(targetProg.start_time),
        targetProg.duration,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToPros)(ChannelColumn);
